import Cookies from 'js-cookie';
import { getGladosUrl } from 'config/index';

const ACCESS_TOKEN_KEY = 'access_token';

export const getRefreshTokenFromCookie = () => {
  return Cookies.get('refreshToken') || null;
};

export const extractIssuer = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload.iss || null;
  } catch {
    return null;
  }
};

export const exchangeToken = async (issuer, refreshToken) => {
  const baseUrl = issuer.replace(/\/+$/, '');
  const response = await fetch(`${baseUrl}/api/v2/auth/access-token`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${refreshToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Token exchange failed: ${response.status}`);
  }

  const data = await response.json();
  return data.access_token;
};

export const authenticate = async () => {
  const refreshToken = getRefreshTokenFromCookie();
  if (!refreshToken) {
    redirectToGlados();
    return null;
  }

  const issuer = extractIssuer(refreshToken);
  if (!issuer) {
    redirectToGlados();
    return null;
  }

  try {
    const accessToken = await exchangeToken(issuer, refreshToken);
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    return accessToken;
  } catch {
    redirectToGlados();
    return null;
  }
};

export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const redirectToGlados = () => {
  localStorage.removeItem('profile');
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  window.location.href = getGladosUrl();
};
